import React from 'react';
import CRMFollowupListConfigModal from './CRMFollowupListConfigModal';

export default function CRMGenericListConfigModal(props) {
  return <CRMFollowupListConfigModal {...props} />;
}
